import {
	Gauge,
	MetricTile,
	ShieldTickSolid,
	StatCard
} from '@clickguard/design-system'
import { RefundsSummaryDTO } from 'api-models'
import ArrowCircleBrokenUp from '@untitled-ui/icons-react/build/esm/ArrowCircleBrokenUp'
import ArrowCircleRight from '@untitled-ui/icons-react/build/esm/ArrowCircleRight'
import CursorClick01 from '@untitled-ui/icons-react/build/esm/CursorClick01'
import moment from 'moment'

/** §5 Overview panel — success gauge + count tiles (no $). Spec B5. */
export const OverviewPanel = ({ summary }: { summary: RefundsSummaryDTO }) => {
	const total = summary.total_submissions
	const successful = summary.successful_submissions
	const pct = total > 0 ? (successful / total) * 100 : 0
	const remainder = Math.max(0, total - successful)

	const nextLabel = summary.next_submission_at
		? moment(summary.next_submission_at).format('MMM D, YYYY')
		: '–'

	return (
		<StatCard
			title="Overview"
			className="h-full refunds-stat-card"
			icon={
				<ShieldTickSolid
					className="w-5 h-5"
					style={{ color: 'var(--color-brand)' }}
				/>
			}
		>
			<div className="flex flex-row items-center gap-3">
				<div className="flex w-[51%] flex-col items-center shrink-0">
					<Gauge
						shape="half"
						segments={[
							{
								value: successful,
								color: 'var(--t-trend-up)',
								label: 'Successful'
							},
							{
								value: remainder,
								color: 'var(--chart-invalid)',
								label: 'Other'
							}
						]}
						max={total > 0 ? total : 1}
					>
						<span className="text-[30px] leading-[36px] font-semibold text-brand-tint-text-strong">
							{pct.toFixed(1)}%
						</span>
					</Gauge>
					<span className="text-[14px] text-t-desc-gray mt-1">
						Successful submissions
					</span>
				</div>

				<div className="relative flex h-[194px] -my-1 min-w-0 flex-1 flex-col justify-between">
					<div>
						<MetricTile
							icon={<ArrowCircleBrokenUp />}
							label="Total submissions"
							value={total.toLocaleString()}
						/>
					</div>
					<div>
						<MetricTile
							icon={<CursorClick01 />}
							label="Total invalid clicks reported"
							value={summary.total_invalid_clicks_reported.toLocaleString()}
						/>
					</div>
					<div>
						<MetricTile
							icon={<ArrowCircleRight />}
							label="Next submission"
							value={nextLabel}
						/>
					</div>
					<span
						className="absolute top-[60px] left-0 right-0 h-px bg-t-traffic"
						aria-hidden="true"
					/>
					<span
						className="absolute top-[133px] left-0 right-0 h-px bg-t-traffic"
						aria-hidden="true"
					/>
				</div>
			</div>
		</StatCard>
	)
}
